import { DataModel } from 'mr-excel';

export function getXLSXDefinitions() {
	const colorPalette = {
		c1: '2C3639',
		c2: 'FFFFFF',
		c3: '000000',
		c4: 'EEEEEE',
	};
	const rowStyle = {
		backgroundColor: colorPalette.c2,
		color: colorPalette.c3,
	};
	const rowStyleDecimal1 = {
		...rowStyle,
		format: 'num_sep_1',
	};
	const rowStyleDecimal2 = {
		...rowStyle,
		format: 'num_sep_2',
	};
	const rowStyleDecimal3 = {
		...rowStyle,
		format: 'float_3',
	};
	const rowStyleDecimal4 = {
		...rowStyle,
		format: 'float_4',
	};
	const rowStyleInteger = {
		...rowStyle,
		format: 'num_sep',
	};
	const headerStyle = {
		backgroundColor: colorPalette.c4,
		color: colorPalette.c1,
		bold: true,
	};
	const headerStyleCenter = {
		backgroundColor: colorPalette.c4,
		color: colorPalette.c1,
		bold: true,
		alignment: {
			horizontal: 'center',
			vertical: 'center',
		} as DataModel.AlignmentOption,
	};
	const rowStyleCenter = {
		backgroundColor: colorPalette.c2,
		color: colorPalette.c3,
		alignment: {
			horizontal: 'center',
			vertical: 'center',
		} as DataModel.AlignmentOption,
	};
	const rowStyleCenterDecimal1 = {
		...rowStyleCenter,
		format: 'num_sep_1',
	};
	const rowStyleCenterDecimal2 = {
		...rowStyleCenter,
		format: 'num_sep_2',
	};
	const rowStyleCenterDecimal3 = {
		...rowStyleCenter,
		format: 'float_3',
	};
	const rowStyleCenterDecimal4 = {
		...rowStyleCenter,
		format: 'float_4',
	};
	const rowStyleCenterInteger = {
		...rowStyleCenter,
		format: 'num_sep',
	};

	const title = {
		backgroundColor: colorPalette.c2,
		whiteSpace: 'pre',
		color: colorPalette.c3,
		bold: true,
		alignment: {
			horizontal: 'center',
			vertical: 'center',
			wrapText: 1,
		} as DataModel.AlignmentOption,
	};

	const estilosDeLinha = {
		rowStyle,
		rowStyleDecimal1,
		rowStyleDecimal2,
		rowStyleDecimal3,
		rowStyleDecimal4,
		rowStyleInteger,
		rowStyleCenter,
		rowStyleCenterDecimal1,
		rowStyleCenterDecimal2,
		rowStyleCenterDecimal3,
		rowStyleCenterDecimal4,
		rowStyleCenterInteger,
	};

	const estilosDeLinhaNaoOficial = Object.fromEntries(
		Object.entries(estilosDeLinha).map(([nome, estilo]) => [
			`${nome}NaoOficial`,
			{ ...estilo, color: 'DC3545' },
		])
	);

	return {
		styles: {
			headerStyle,
			headerStyleCenter,
			...estilosDeLinha,
			...estilosDeLinhaNaoOficial,
			title,
		},
	};
}

export function getXLSXSheetDefinitions(colunasAEsquerda: number[] = []) {
	return {
		shiftTop: 3,
		styleCellCondition(
			data: any,
			object: any,
			rowIndex: number,
			colIndex: number
		) {
			if (data?.label) {
				return 'headerStyleCenter';
			} else {
				return colunasAEsquerda.includes(colIndex)
					? 'rowStyle'
					: 'rowStyleCenter';
			}
		},
		images: [
			{
				url: 'assets/images/cabecalho/cabeçalho_excel.png',
				from: 'A1',
				to: 'C3',
			},
		],
	};
}

export function getXLSXSheetTitleDefinitions() {
	return {
		consommeRow: 3,
		consommeCol: 3,
		styleId: 'title',
	};
}
